<template>
   <!-- 分配用户的对话框 -->
    <div>
        <!-- 面包屑导航区域 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>树形字典</el-breadcrumb-item>
        <el-breadcrumb-item>树形明细</el-breadcrumb-item>
        </el-breadcrumb>
      <!-- 卡片视图区域 -->
      <el-card style="height:800px" >
         <el-page-header @back="goBack" :content="treeName"></el-page-header>
         <el-divider></el-divider>
        <el-row>
          <el-col :span="8">
            <el-tree
              node-key="id"
              class="filter-tree"
              :data="treeData"
              :props="defaultProps"
              :default-expand-all="false"
              ref="tree"
              @node-click="handleNodeClick"
              :default-expanded-keys="expandKeys"
              >
            </el-tree>
            
          </el-col>
   
          <el-col :span="16">
              <el-row type="flex" justify="end">
                <el-col class="searchBtns" :span="6">
                  <el-button-group>
                    <el-button plain size="small" icon="el-icon-plus" v-if="currentParentId !=null" @click="showAddDialog" v-hasPermission="['tree:save']">新增</el-button>
                    <el-button plain size="small" icon="el-icon-delete" v-if="currentParentId !=null"  @click="deletes" v-hasPermission="['tree:delete']" >删除</el-button>
                    <el-button plain size="small" icon="el-icon-download" @click="exportExcel" v-hasPermission="['tree:export']">导出Excel</el-button>
                  </el-button-group>
                </el-col>
              </el-row>

              <!-- 列表区域 -->
              <el-table :data="dataList" border stripe  @selection-change="handleSelectionChange" @sort-change="sortChange" > 
                <el-table-column
                  type="selection"
                  width="55" >
                </el-table-column>
                <el-table-column type="index" label="No."></el-table-column>
                <el-table-column label="明细名称"   prop="label"></el-table-column>
                <el-table-column label="明细编码" prop="code"></el-table-column>
                 <el-table-column label="排序"  prop="sortNo"></el-table-column>
              <el-table-column label="父级"  prop="parentName"></el-table-column>
                <el-table-column label="状态"  prop="status">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status==='Y'" type="success">生效</el-tag>
                    <el-tag v-else-if="scope.row.status==='N'" type="info">失效</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="180px">
                <template slot-scope="scope">

                  <el-link icon ="el-icon-edit" @click="showEditDialog(scope.row.id)"  v-hasPermission="['tree:delete']"
                    >编辑</el-link
                  >
                </template>
              </el-table-column>
              </el-table>

              <!-- 分页区域 -->
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfoparams.current"
                :page-sizes="[10, 50, 100, 200]"
                :page-size="queryInfoparams.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
          </el-col>
        </el-row>
       
          
        </el-card>

        <!-- 添加角色的对话框 -->
    <el-dialog
        :visible="addDialogVisible"
        width="40%"
        @close="closeDialog"
        slot="title"
        >
        <template slot="title">
          <div>
            <h3>添加明细</h3>
            <el-divider style="font-weight:bold;"></el-divider>
          </div>
        </template>
             <!-- 内容主体区域 -->
          <el-form
            :model="addForm"
            :rules="addFormRules"
            ref="addFormRef"
            label-width="70px"
          >
            <el-form-item label="明细名称" prop="label" label-width="100px">
              <el-input v-model="addForm.label"></el-input>
            </el-form-item>
            <el-form-item label="明细编码" prop="code" label-width="100px">
              <el-input v-model="addForm.code"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sortNo" label-width="100px">
              <el-input v-model="addForm.sortNo" type="number"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status" label-width="100px">
              <el-radio-group v-model="addForm.status">
                <el-radio label="Y">生效</el-radio>
                <el-radio label="N">失效</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>

            <!-- 底部区域 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
    </el-dialog>
    </div>
</template>

<script>

export default {
    props:{
        visible:{
            default:false
        }
    },
  data() {
    
    return {
      // 获取用户列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
       // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,
      //列表
      dataList: [],
      total: 0,
      //角色用户列表的checkbox值
       multipleSelection:[],
       //搜索列表的checkbox值
      multipleSelectionSearch:[],
      //搜索用户列表
      searchDataList:[],
        // 获取用户列表的参数对象
      searchQueryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
    
      searchTotal:0,
      treeName:this.$route.query.treeName+' 树形列表',
      treeId:this.$route.query.treeId,

      //当前点击的树节点ID，默认是-1第一层
      currentParentId:null,
      //搜索内容
      searchContent:null,

      filterText: '',
      //树列表 数据
      treeData: [],
      //展开的节点数组
      expandKeys:[-1],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      //新增
      addForm:{
        status:'Y'
      },
       // 添加表单的验证规则对象
      addFormRules: {
        label: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '编码不能为空', trigger: 'blur' }
        ],
      },


    }
  },
  created(){
      
      this.getTreeData()
      // this.getDataList()
  },
  methods: {
     //导出excel
    exportExcel() {
      console.log('-----------')
      var params = {'treeId':this.treeId}

      let res = this.$export('tree/item/exportExcel', JSON.stringify(params), 'tree')
    },
    
    //监听字段排序
    sortChange(r){
      //设置排序字段名
      this.queryInfoparams.sortField=r.prop
       //设置排序字段名
      this.queryInfoparams.sortOrder=r.order

      this.getDataList()
    },
    // 获取 查询用户数据列表
    getDataList() {
 
        // 分页查询用户
        this.queryInfoparams.params.treeId=this.treeId
        this.queryInfoparams.params.parentId=this.currentParentId
        this.$post('/tree/item/pageQuery', this.queryInfoparams).then(
          ({ data: res }) => {
            this.dataList = res.records
            this.total = res.total
          }
        )
    },
    getTreeData(){

      this.$get(`tree/getTreeById/${this.treeId}`).then(({ data: res }) => {
        console.log(res)
        this.treeData = res.data
      })
    },
    handleNodeClick(data){
      console.log(data.id)
      this.currentParentId=data.id
      this.getDataList()
    },
    showAddDialog(){
        this.addDialogVisible=true
    },
    showEditDialog(id){
      this.addDialogVisible=true
      this.$get(`tree/item/get/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm = res.data
      })
    },
    closeDialog(){
      this.addForm={status:'Y'}
        this.addDialogVisible =false
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听对话框的关闭事件
    goBack () {
      this.$router.back()
    },
    // 点击按钮 新增保存
    async save() {
      

      this.$refs.addFormRef.validate(async (valid) => {
        //父级ID
        
         this.addForm.parentId=this.currentParentId
         this.addForm.treeId=this.treeId
         
        if (!valid) return
        this.$post('tree/item/save', this.addForm).then(({ data: res }) => {
          if (res.ok) {
            // 刷新列表数据
            this.getDataList()
            this.getTreeData()
            this.closeDialog()
            this.expandKeys=[this.currentParentId]

            return this.$message.success('提交成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },

  //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
    },

    //监控搜索页面 checkbox的选择,为entity的所有值
    handleSelectionChangeSearch(val) {
        this.multipleSelectionSearch = val;
        console.log(this.multipleSelectionSearch)
    },
    // 批量删除
    async deletes() {

      if(this.multipleSelection ==null || this.multipleSelection.length<=0){
         return this.$message.error('请先勾选要删除的数据')

      }
     
       var ids =[]
        this.multipleSelection.forEach(row => {
          ids.push(row.id)
        });

      console.log(ids)

    
       const confirmResult = await this.$confirm(
       '此操作将永久删除, 是否继续?',
        '删除明细',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).then(() => {
         this.$delete(`tree/item/batchDelete`, {idList:ids}).then(({ data: res }) => {
            if (! res.ok ) {
              return this.$message.error(res.msg)
            }
            this.$message.success(res.msg)

            this.getDataList()
          })

        }).catch(() =>{
          
        })
    }
  }
}
</script>

<style lang="less" scoped>
.rightContent {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}
</style>